import moment from 'moment';
import { sum, cloneDeep } from 'lodash-es';
import { useStore } from 'vuex';
import VueJwtDecode from 'vue-jwt-decode';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
import { APPROVAL_STATE } from './type';
import { TypeGetter } from './type/get';
import { daysBetween } from '@quasar/quasar-ui-qcalendar';

// const store = useStore();
let count = 0;

export const Moment = {
  now: moment(),
  defaultMonth: moment().subtract(3, 'months').startOf('months'),
  nowYYYYMMDD: moment().format('YYYY-MM-DD'),
  format(date, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!date) return date;
    return moment(date).locale('ko').format(format);
  },
  getStartOfMonth(date) {
    return moment(date).startOf('month');
  },
  getEndOfMonth(date) {
    return moment(date).endOf('month');
  },
  getFormat(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  },
  getYYYYMMDD(date) {
    return moment(date).locale('ko').format('YYYY.MM.DD');
  },
  getYYYYMM(date) {
    return moment(date).locale('ko').format('YYYY.MM');
  },
  getYYYYMM01(date) {
    return moment(date).locale('ko').format('YYYY-MM-01');
  },
  getYYYYMM30(date) {
    return moment(date).locale('ko').format('YYYY-MM-30');
  },
  getYYYYMMDDandDay(date) {
    return moment(date).locale('ko').format('YYYY.MM.DD (dd)');
  },
  getMMDDandDay(date) {
    return moment(date).locale('ko').format('MM.DD (dd)');
  },
  getIPhoneDate(date) {
    return moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
  },
  getYYYY_MM_DD(date) {
    return moment(date).locale('ko').format('YYYY-MM-DD');
  },
  getDefaultYearMonth(date) {
    return moment(date).locale('ko').format('YYYY/MM');
  },
  getQdateForm(date) {
    return moment(date).locale('ko').format('YYYY/MM/DD');
  },
  diffYear(to, from) {
    return moment(from).diff(moment(to), 'year');
  },
  diffMonth(to, from) {
    return moment(from).diff(moment(to), 'month');
  },
  diffDay(to, from) {
    return moment(from).diff(moment(to), 'days');
  },
  diffDayNew(to, from) {
    if (!to || !from) return 0;
    return moment(from).diff(moment(to), 'days');
  },
  diffHours(to, from) {
    return moment(from).diff(moment(to), 'hours');
  },
  diffMinutes(to, from) {
    return moment(from).diff(moment(to), 'minutes');
  },
  getYear(date) {
    // month가 0부터 시작. ex) 1월 = 0, 2월 = 1
    return moment(date).year();
  },
  getMonth(date) {
    // month가 0부터 시작. ex) 1월 = 0, 2월 = 1
    return moment(date).month() + 1;
  },
  getDate(date) {
    return moment(date).date();
  },
  getHHmm(date) {
    return moment(date).format('HH:mm');
  },
  setMonth(date) {
    return moment(date).format('YYYY-MM');
  },
  getDay(date) {
    return moment(date).day();
  },
  setTimeDate(time, date) {
    const d = moment(date);
    const t = moment(time, 'HH:mm');
    return d.set({ hour: t.get('hour'), minute: t.get('minute'), second: '00' }) ?? false;
  },
  getMonthDuration(date) {
    //근태현황 - 월별 검색
    const startOfMonth = moment(date).startOf('month').format('YYYY-MM-DD');
    const endOfMonth = moment(date).endOf('month').format('YYYY-MM-DD');
    return { from: startOfMonth, to: endOfMonth };
  },
  getDayDuration() {
    //근태현황 - 일별 검색
    const now = moment().format('YYYY-MM-DD');
    const lastMonth = moment().subtract(1, 'months').format('YYYY-MM-DD');
    const startOf = moment(lastMonth).startOf('month').format('YYYY-MM-DD');
    const currentDay = moment(now).add(0, 'days').format('YYYY-MM-DD');
    const lastDay = moment(startOf).add(14, 'days').format('YYYY-MM-DD');
    return { from: lastDay, to: currentDay };
  },
  getYearDuration() {
    //현재 연도 1년치
    const now = moment();
    const nowYear = moment(now).year();
    const startDay = moment(nowYear.toString()).format('YYYY-MM-DD');
    const lastMonth = moment(startDay).add(11, 'months').format('YYYY-MM-DD');
    const lastDay = moment(lastMonth).add(30, 'day').format('YYYY-MM-DD');
    return { from: startDay, to: lastDay };
  },
  dayFormat(date, format) {
    const day = ['일', '월', '화', '수', '목', '금', '토'];
    const toDate = date ? moment(date, 'YYYY-MM-DD') : moment();
    return `${toDate.format(format || 'YYYY.MM.DD')}(${day[toDate.day()]})`;
  },
  getDateBefore(date) {
    if (date) {
      if (Moment.diffMonth(date, moment()) > 0) {
        return `${Moment.diffMonth(date, moment())} 달 전`;
      } else if (Moment.diffDay(date, moment()) > 0) {
        return `${Moment.diffDay(date, moment())} 일 전`;
      } else if (Moment.diffHours(date, moment()) > 0) {
        return `${Moment.diffHours(date, moment())} 시간 전`;
      } else if (Moment.diffMinutes(date, moment()) > 0) {
        return `${Moment.diffMinutes(date, moment())} 분 전`;
      }
    }
    return '지금';
  },
  getCurrentMonthLimit(date, workedMonth) {
    const startOf = moment(workedMonth)
      .startOf('month')
      .locale('ko')
      .format('YYYY/MM/DD');
    const endOf = moment(workedMonth).endOf('month').locale('ko').format('YYYY/MM/DD');
    return date >= startOf && date <= endOf;
  },
  weekendLimit(date) {
    const day = moment(date, 'YYYY.MM.DD').day();
    const saturday = 6;
    const sunday = 0;
    return day != saturday && day != sunday;
  },
  getAllDateToNow(date) {
    const now = moment().locale('ko').format('YYYY/MM/DD');
    return date <= now;
  },
  getAllDateToYear(date) {
    const now = moment();
    const nowYear = moment(now).year();
    const startDay = moment(nowYear.toString()).format('YYYY/MM/DD');
    const lastMonth = moment(startDay).add(11, 'months').format('YYYY/MM/DD');
    const lastDay = moment(lastMonth).add(30, 'day').format('YYYY/MM/DD');
    return date >= startDay && date <= lastDay;
  },
  add(date, num) {
    return moment(date).add(num, 'days').format();
  },
  businessDays(firstDate, secondDate) {
    const format = 'YYYY.MM.DD';
    let day1 = moment(firstDate, format).startOf('day');
    let day2 = moment(secondDate, format).startOf('day');

    let adjust = 1;
    if (day1.dayOfYear() === day2.dayOfYear() && day1.year() === day2.year()) {
      return 0;
    }
    if (day2.isBefore(day1)) {
      const temp = day1;
      day1 = day2;
      day2 = temp;
    }
    if (day1.day() === 6) {
      //Saturday
      day1.day(8);
    } else if (day1.day() === 0) {
      //Sunday
      day1.day(1);
    }

    if (day2.day() === 6) {
      //Saturday
      day2.day(5);
    } else if (day2.day() === 0) {
      //Sunday
      day2.day(-2);
    }

    const day1Week = day1.week();
    let day2Week = day2.week();
    if (day1Week !== day2Week) {
      if (day2Week < day1Week) {
        day2Week += day1Week;
      }
      adjust += -2 * (day2Week - day1Week);
    }
    return day2.diff(day1, 'days') + adjust;
  },
  getWeekday(date) {
    return moment(date).weekday();
  },
  isBetween(startDt, endDt, date) {
    const d = moment(date);
    return d.isSameOrAfter(startDt) && d.isSameOrBefore(endDt);
    //
    // const from = Moment.format();
    // const to = moment(endDt).add(1, 'days');
    // const from = moment(startDt).add(-1, 'days');
    // const to = moment(endDt).add(1, 'days');
    // return moment(date).isBetween(from, to);
  },
  getOnedayOrDuration(start, end) {
    if (!start || !end) {
      return ' - ';
    }

    let result;
    if (Moment.diffDay(start, end) === 0) {
      result = Moment.getYYYYMMDD(start);
    } else {
      result = `${Moment.getYYYYMMDD(start)} ~ ${Moment.getYYYYMMDD(end)}`;
    }
    return result;
  },
  getOnedayOrDuration2(start, end) {
    if (!start || !end) {
      return ' - ';
    }

    let result;
    if (Moment.diffDay(start, end) === 0) {
      result = Moment.getYYYYMMDDandDay(start);
    } else {
      result = `${Moment.getYYYYMMDDandDay(start)} ~ ${Moment.getYYYYMMDDandDay(end)}`;
    }
    return result;
  },
  sortByDate(dateArray, key, asc) {
    return dateArray.sort((a, b) => {
      if (a[key] && b[key]) {
        const dateA = moment(Moment.getYYYY_MM_DD(a[key]));
        const dateB = moment(Moment.getYYYY_MM_DD(b[key]));
        if (asc && asc != 'desc') {
          return dateA.diff(dateB);
        }
        return dateB.diff(dateA);
      } else if (a[key]) {
        return -1;
      } else if (b[key]) {
        return 1;
      } else {
        return 0;
      }
    });
  },
  getDateList(start, end, format) {
    const list = [];
    const diff = this.diffDayNew(start, end);

    for (var i = 0; i <= diff; i++) {
      const day = this.add(start, i);
      list.push(moment(day).format(format || 'YYYY/MM/DD'));
    }
    return list;
  },
};

export const Utils = {
  addComma(num) {
    return num ? parseInt(num).toLocaleString('ko-KR') : 0;
  },
  // deleteComma(num) {
  //   num = String(num)
  //   return parseInt(num.toLocaleString('ko-KR').replace(/,/g,""))
  // },
  comma(num) {
    // return num.toLocaleString('ko-KR').replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    const parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },
  sum(numList) {
    return sum(numList);
  },
  deepCopy(target) {
    return cloneDeep(target);
  },
  sortByOrder(list) {
    const result = [];
    for (var i = 1; i <= list.length; i++) {
      result.push(list.find((member) => member.order === i));
    }
    return result;
  },
  sortByFavorites(list) {
    const result = [];
    list.forEach((member) => {
      if (member.favorites === true) {
        result.push(member);
      }
    });
    list.forEach((member) => {
      if (member.favorites === false) {
        result.push(member);
      }
    });
    return result;
  },
  toConsonant(str) {
    const consonant = [
      'ㄱ',
      'ㄲ',
      'ㄴ',
      'ㄷ',
      'ㄸ',
      'ㄹ',
      'ㅁ',
      'ㅂ',
      'ㅃ',
      'ㅅ',
      'ㅆ',
      'ㅇ',
      'ㅈ',
      'ㅉ',
      'ㅊ',
      'ㅋ',
      'ㅌ',
      'ㅍ',
      'ㅎ',
    ];
    let result = '';
    for (let i = 0; i < str.length; i++) {
      let code = str.charCodeAt(i) - 44032;
      if (code > -1 && code < 11172) {
        result += consonant[Math.floor(code / 588)];
      }
    }
    return result;
  },
  replaceToBr(str) {
    const result = str.replace(/(\n|\r\n)/g, '<br>');
    return result;
  },
  setAlarmMessage(alarmOrigin, employeeId) {
    let alarm = Utils.deepCopy(alarmOrigin);

    if (alarm.cate === 'employee') {
      // 1. 인사 관리
      if (alarm.item === 'rank') {
        // (1). 수석 직급으로 변경 되었습니다 - 직급 변경 case
        alarm.message = `${alarm.element} 직급으로 변경되었습니다`;
        alarm.data.path = `/hr/management/current/detail/${employeeId}`;
      } else if (alarm.item === 'team') {
        // (2). UI/UX 부서로 이동되었습니다 - 부서 변경 case
        alarm.message = `${alarm.element} 부서로 이동되었습니다`;
        alarm.data.path = `/hr/management/current/detail/${employeeId}`;
      } else if (alarm.item === 'receipt') {
        // (3). 전년도 원천징수 영수증 case
        if (alarm.optionInt1) {
          alarm.message = `${alarm.element} 님 외 ${alarm.optionInt1}명이 전년도 원천징수영수증을 신청하였습니다`;
        } else {
          alarm.message = `${alarm.element} 님이 전년도 원천징수영수증을 신청하였습니다`;
        }
      } else if (alarm.item === 'certificate') {
        // (4). 재직 증명서 case
        if (alarm.optionInt1) {
          alarm.message = `${alarm.element} 님 외 ${alarm.optionInt1}명이 재직증명서를 신청하였습니다`;
        } else {
          alarm.message = `${alarm.element} 님이 재직증명서를 신청하였습니다`;
        }
      }
    } else if (alarm.cate === 'attendance') {
      // 2. 근태 관리
      if (alarm.action === 'change') {
        //(1). 지각처리 case
        alarm.message = `${Moment.getYYYYMMDDandDay(alarm.element)} 지각 처리되었습니다`;
      } else if (alarm.action === 'approve') {
        //(2) 출퇴근 시간 변경 요청건이 승인되었습니다 case
        alarm.message = '출퇴근 시간 변경 요청 건이 승인되었습니다';
      } else if (alarm.action === 'reject') {
        //(3) 출퇴근 시간 변경 요청 건이 반려되었습니다 case
        alarm.message = '출퇴근 시간 변경 요청 건이 반려되었습니다';
      } else if (alarm.action === 'request') {
        //(4) ~요청 건이 있습니다. case
        if (alarm.optionInt1) {
          alarm.message = `${alarm.element} 님 외 ${alarm.optionInt1}명의 출퇴근 시간 변경 요청 건이 있습니다`;
        } else {
          alarm.message = `${alarm.element} 님의 출퇴근 시간 변경 요청 건이 있습니다`;
        }
      }
    } else if (alarm.cate === 'vacation') {
      // 2. 연차 관리
      if (alarm.item === 'vacationManage') {
        if (alarm.action === 'change') {
          if (alarm.element) {
            if (alarm.optionInt1) {
              //000 님 외 20명이 1년차로 연차를 수정하세요
              alarm.message = `${alarm.element} 님 외 ${alarm.optionInt1}명이 1년차로 연차를 수정하세요`;
              alarm.data.path = '/vacation/management';
            } else {
              //000 님이 1년차로 연차를 수정하세요 case
              alarm.message = `${alarm.element} 님이 1년차로 연차를 수정하세요`;
              alarm.data.path = '/vacation/management';
            }
          } else {
            //관리자에 의해 연차 현황이 변경되었습니다 case
            alarm.message = '관리자에 의해 연차 현황이 변경되었습니다';
          }
        } else if (alarm.action === 'alert') {
          //연차 촉진 메일이 발송되었으니 메일을 확인하세요 case
          alarm.message = '연차 촉진 메일이 발송되었으니 메일을 확인하세요';
        }
      } else if (alarm.item === 'admit') {
        if (alarm.action === 'alert') {
          //사용기한이 1주 남은 인정 휴가가 있습니다. case
          alarm.message = '사용기한이 1주 남은 인정휴가가 있습니다';
        }
      }
    } else if (alarm.cate === 'approval') {
      // 3. 결재 관리
      if (alarm.item === 'application') {
        if (alarm.action === 'request') {
          // 현재 미결재 문서 case
          alarm.message = `현재 미결재 문서 ${alarm.optionInt1}건이 있습니다`;
        }
      } else if (alarm.item === 'mealCost') {
        //식대비
        if (alarm.action === 'approve') {
          if (alarm.element) {
            alarm.message = `${alarm.element} 님의 식대비가 결재완료 되었습니다`;
            alarm.data.path = `/approval/box/applied/mealcost/detail/${alarm.optionStr1}`;
          } else {
            alarm.message = '식대비가 결재 완료 되었습니다';
            alarm.data.path = `/approval/box/applied/mealcost/detail/${alarm.optionStr1}`;
          }
        } else if (alarm.action === 'reject') {
          alarm.message = '식대비가 3단계에서 반려 되었습니다';
          alarm.data.path = `/approval/box/applied/mealcost/detail/${alarm.optionStr1}`;
        }
      } else if (alarm.item === 'expenseReport') {
        //지출 결의서
        if (alarm.action === 'approve') {
          if (alarm.element) {
            alarm.message = `${alarm.element} 님의 지출결의서가 결재완료 되었습니다`;
            alarm.data.path = `/approval/box/applied/expense/detail/${alarm.optionStr1}`;
          } else {
            alarm.message = '지출결의서가 결재 완료 되었습니다';
            alarm.data.path = `/approval/box/applied/expense/detail/${alarm.optionStr1}`;
          }
        } else if (alarm.action === 'reject') {
          alarm.message = '지출결의서가 3단계에서 반려 되었습니다';
          alarm.data.path = `/approval/box/applied/expense/detail/${alarm.optionStr1}`;
        }
      } else if (alarm.item === 'submit') {
        //품의서
        if (alarm.action === 'approve') {
          if (alarm.element) {
            alarm.message = `${alarm.element} 님의 품의서가 결재완료 되었습니다`;
            alarm.data.path = `/approval/box/applied/submit/detail/${alarm.optionStr1}`;
          } else {
            alarm.message = '품의서가 결재 완료 되었습니다';
            alarm.data.path = `/approval/box/applied/submit/detail/${alarm.optionStr1}`;
          }
        } else if (alarm.action === 'reject') {
          alarm.message = '품의서가 3단계에서 반려 되었습니다';
          alarm.data.path = `/approval/box/applied/submit/detail/${alarm.optionStr1}`;
        }
      } else if (alarm.item === 'holidayWork') {
        //휴일 근무
        if (alarm.action === 'approve') {
          if (alarm.element) {
            alarm.message = `${alarm.element} 님의 휴일 근무가 결재 완료 되었습니다`;
            alarm.data.path = `/approval/box/applied/holidaywork/detail/${alarm.optionStr1}`;
          } else {
            alarm.message = '휴일 근무가 결재 완료 되었습니다';
            alarm.data.path = `/approval/box/applied/holidaywork/detail/${alarm.optionStr1}`;
          }
        } else if (alarm.action === 'reject') {
          alarm.message = '휴일 근무가 3단계에서 반려 되었습니다';
          alarm.data.path = `/approval/box/applied/holidaywork/detail/${alarm.optionStr1}`;
        }
      } else if (alarm.item === 'admitRequest') {
        //인정 휴가 지급
        if (alarm.action === 'approve') {
          if (alarm.element) {
            alarm.message = `${alarm.element} 님의 인정 휴가 지급이 결재 완료 되었습니다`;
            alarm.data.path = `/approval/box/applied/admit/detail/${alarm.optionStr1}`;
          } else {
            alarm.message = '인정 휴가 지급이 결재 완료 되었습니다';
            alarm.data.path = `/approval/box/applied/admit/detail/${alarm.optionStr1}`;
          }
        } else if (alarm.action === 'reject') {
          alarm.message = '인정 휴가 지급이 3단계에서 반려 되었습니다';
          alarm.data.path = `/approval/box/applied/admit/detail/${alarm.optionStr1}`;
        }
      } else if (alarm.item === 'businessTrip') {
        //출장결과보고서
        if (alarm.action === 'approve') {
          if (alarm.element) {
            alarm.message = `${alarm.element} 님의 출장 결과보고서가 결재 완료 되었습니다`;
            alarm.data.path = `/approval/box/applied/businesstrip/detail/${alarm.optionStr1}`;
          } else {
            alarm.message = '출장 결과보고서가 결재 완료 되었습니다';
            alarm.data.path = `/approval/box/applied/businesstrip/detail/${alarm.optionStr1}`;
          }
        } else if (alarm.action === 'reject') {
          alarm.message = '출장 결과보고서가 3단계에서 반려 되었습니다';
          alarm.data.path = `/approval/box/applied/businesstrip/detail/${alarm.optionStr1}`;
        }
      } else if (alarm.item === 'vacationUpdate') {
        //휴가 취소 요청 건
        if (alarm.action === 'approve') {
          alarm.message = '휴가 취소 요청 건이 승인되었습니다';
          alarm.data.path = '/approval/box/reception/vacation';
        } else if (alarm.action === 'reject') {
          alarm.message = '휴가 취소 요청 건이 반려되었습니다';
          alarm.data.path = '/approval/box/reception/vacation';
        }
      }
    } else if (alarm.cate === 'notice') {
      alarm.message = '신규 공지사항이 업데이트 되었습니다';
      alarm.data.path = `/notice/current/detail/${alarm.element}`;
    }

    return alarm;
  },
  getCostFromMasked(masked) {
    if (!masked) {
      return 0;
    } else if (!masked.includes(',')) {
      return parseInt(masked);
    }
    return parseInt(masked.replace(/,/g, ''));
  },
  checkNightShiftTime(start, end) {
    const from = Moment.getDate(start);
    const to = Moment.getDate(end);
    const isNext = to - from;

    if (Moment.getHHmm(end) < '21:00' && (isNext === 0 || isNaN(isNext))) {
      return true;
    }
    return false;
  },
  setStoreData(key, data) {
    store.dispatch('pageData/set', { [key]: data });
  },
  getStoreData(key) {
    return store.getters['pageData/get']?.[key];
  },
  setPageData(key, data) {
    const currentPath = router.currentRoute.value.fullPath;
    const pageData = this.getPageData();
    pageData[key] = data;
    store.dispatch('pageData/set', { path: currentPath, data: pageData });
  },
  getPageData(key) {
    const currentPath = router.currentRoute.value.fullPath;
    const stored = store.getters['pageData/get']?.[currentPath];
    if (!stored) return {};
    if (key) {
      return stored[key];
    }
    return stored;
  },
  deletePageData(key) {
    const currentPath = router.currentRoute.value.fullPath;
    const stored = store.getters['pageData/get']?.[currentPath];
    if (!stored) return;
    if (key) {
      store.dispatch('pageData/delete', { path: currentPath, key });
    } else {
      store.dispatch('pageData/delete', { path: currentPath });
    }
  },
  setPageDataLocal(key, data) {
    const currentPath = router.currentRoute.value.fullPath;
    const stored = this.getPageDataLocal();
    stored[key] = data;
    stored[key].expiration = Moment.format(Moment.now, 'YYYY-MM-DD HH:mm:ss');
    this.setLocalStorage(currentPath, stored);
  },
  getPageDataLocal(key) {
    const currentPath = router.currentRoute.value.fullPath;
    const stored = this.getLocalStorage(currentPath);
    if (!stored) return {};

    Object.keys(stored).forEach((key) => {
      const storedTime = stored[key]?.expiration;
      if (Moment.diffHours(storedTime, Moment.now) > 12) {
        this.deletePageDataLocal(key);
      } else {
        delete stored[key]?.expiration;
      }
    });

    if (key) {
      return stored[key];
    }
    return stored;
  },
  deletePageDataLocal(key) {
    const currentPath = router.currentRoute.value.fullPath;
    if (key) {
      const stored = this.getLocalStorage(currentPath);
      if (!stored) return;
      delete stored[key];
      this.setLocalStorage(currentPath, stored);
    } else {
      localStorage.removeItem(currentPath);
    }
  },
  setPageParams(params) {
    this.setPageData('params', params);
  },
  getPageParams() {
    const params = this.getPageData('params');
    if (Object.keys(params ?? {}).length == 0) {
      return null;
    }
    return params;
  },
  createUrlListFromHtml(html, option) {
    if (!html.includes('<img src=')) return [];

    let _list = [];
    const htmlSplited = html.split('<img src=');
    htmlSplited.splice(1).forEach((text) => {
      let src = text.split('"')[1];
      if (option) {
        src = option(src);
      }
      if (src) {
        _list.push(src);
      }
    });
    return _list;
  },
  getApprovalStage(row) {
    const approval = TypeGetter.getApprovalStateType(row.approvalState);
    switch (approval.KEY) {
      case APPROVAL_STATE.APPLIED.KEY:
        return `1/${row.countApprovalBoard}단계 (${row.currentNameKr})`;
      case APPROVAL_STATE.IN_PROGRESS.KEY:
        return `${row.currentOrder}/${row.countApprovalBoard}단계 (${row.currentNameKr})`;
      default:
        return approval.NAME;
    }
  },
  jsonToString(value) {
    if (typeof value === 'object') {
      return JSON.stringify(value);
    } else {
      return console.error('jsonToString() error: input type error');
    }
  },
  jsonFromString(value) {
    let parsed = '';
    if (typeof value === 'string') {
      try {
        parsed = JSON.parse(value);
      } catch {
        parsed = value;
      }
      return parsed;
    } else {
      return console.error('jsonFromString() error: input type error');
    }
  },
  setLocalStorage(key, val) {
    if (typeof val === 'object') {
      val = this.jsonToString(val);
    }
    localStorage.setItem(key, window.btoa(encodeURIComponent(val)));
  },
  getLocalStorage(key) {
    let val = localStorage.getItem(key);
    if (val != null) {
      const decoded = decodeURIComponent(window.atob(val));
      const parsed = this.jsonFromString(decoded);
      if (typeof parsed === 'object') {
        return parsed;
      }
      return decoded;
    }
    return null;
  },
  setSessionStorage(key, val) {
    if (typeof val === 'object') {
      val = this.jsonToString(val);
    }
    sessionStorage.setItem(key, window.btoa(encodeURIComponent(val)));
  },
  getSessionStorage(key) {
    let val = sessionStorage.getItem(key);
    if (val != null) {
      const decoded = decodeURIComponent(window.atob(val));
      const parsed = this.jsonFromString(decoded);
      if (typeof parsed === 'object') {
        return parsed;
      }
      return decoded;
    }
    return null;
  },
  insertStr(origin, str, lengthToSplit) {
    const regexPattern = new RegExp(`.{1,${lengthToSplit}}`, 'g');
    const chunks = origin.match(regexPattern);
    const formattedChunks = chunks.map((chunk) => chunk + str);
    formattedChunks[formattedChunks.length - 1] = chunks[chunks.length - 1];
    return formattedChunks.join('');
  },
  groupByProperty(origin, property) {
    return origin.reduce((map, item) => {
      const value = item[property];
      if (!map[value]) map[value] = [];
      map[value].push(item);
      return map;
    }, {});
  },
  sortObjectArray(array, key, asc) {
    return array.sort((a, b) => {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    });
  },
  getDateEvents() {
    const holidays = this.getLocalStorage('holidays') ?? [];
    const alldays = this.getLocalStorage('vacations')?.alldays ?? [];
    const halfdays = this.getLocalStorage('vacations')?.halfdays ?? [];
    return [...holidays, ...alldays, ...halfdays];
  },
  setDateEventsColors(date) {
    const holidays = this.getLocalStorage('holidays') ?? [];
    const alldays = this.getLocalStorage('vacations')?.alldays ?? [];
    const halfdays = this.getLocalStorage('vacations')?.halfdays ?? [];
    if (holidays.includes(date)) return 'red';
    else if (alldays.includes(date)) return 'green-6';
    else if (halfdays.includes(date)) return 'green-2';
    return 'white';
  },

  getBytes(str) {
    let charBytes = 0;

    for (let i = 0; i < str.length; i++) {
      const character = str.charAt(i);
      charBytes += encodeURI(character).length > 4 ? 2 : 1;
    }

    return charBytes;
  },

  convExcelFormation(number) {
    let result = '';

    while (number > 0) {
      const remainder = (number - 1) % 26;
      result = String.fromCharCode(65 + remainder) + result;
      number = Math.floor((number - 1) / 26);
    }

    return result;
  },

  mergeTables(...tables) {
    const tableList = tables.flatMap((table) =>
      table instanceof HTMLCollection
        ? Array.from(table)
        : table instanceof HTMLTableElement
        ? [table]
        : []
    );

    const tr = { thead: [], tbody: [] };

    tableList.forEach((table) => {
      // Thead 처리
      Array.from(table.querySelectorAll('thead tr')).forEach((trItem, index) => {
        if (!tr.thead[index]) tr.thead[index] = [];
        tr.thead[index].push(
          ...Array.from(trItem.children).map((thItem) => thItem.cloneNode(true))
        );
      });

      // Tbody 처리
      Array.from(table.querySelectorAll('tbody tr')).forEach((trItem, index) => {
        if (!tr.tbody[index]) tr.tbody[index] = [];
        tr.tbody[index].push(
          ...Array.from(trItem.children).map((tdItem) => tdItem.cloneNode(true))
        );
      });
    });

    // 병합된 테이블 생성
    const mergeTable = document.createElement('table');
    const thead = document.createElement('thead');
    const tbody = document.createElement('tbody');

    tr.thead.forEach((thRow) => {
      const tr = document.createElement('tr');
      thRow.forEach((thItem) => tr.appendChild(thItem));
      thead.appendChild(tr);
    });

    tr.tbody.forEach((tdRow) => {
      const tr = document.createElement('tr');
      tdRow.forEach((tdItem) => tr.appendChild(tdItem));
      tbody.appendChild(tr);
    });

    mergeTable.appendChild(thead);
    mergeTable.appendChild(tbody);

    return mergeTable;
  },

  rgbToHex(rgb) {
    if (rgb === 'blue') return '0000ff';
    if (rgb === 'red') return 'ff0000';

    const rgbRegex = /^rgb\(\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*\)$/;
    const result = rgbRegex.exec(rgb);

    if (result === null) return '';

    const r = Number(result[1]).toString(16);
    const g = Number(result[3]).toString(16);
    const b = Number(result[5]).toString(16);

    return `${r.padStart(2, '0')}${g.padStart(2, '0')}${b.padStart(2, '0')}`;
  },

  makeXlsxStyle(table) {
    const style = {};
    const rowSpanInfo = { count: 0, col: -1 };

    // 헬퍼 함수: 스타일 병합
    const createStyle = (cellStyle, { bold, color, bg }) => {
      const result = {};
      if (bold) result.font = { ...(result.font || {}), bold: true };
      if (color)
        result.font = { ...(result.font || {}), color: { rgb: this.rgbToHex(color) } };
      if (bg) result.fill = { fgColor: { rgb: this.rgbToHex(bg) }, patternType: 'solid' };
      return result;
    };

    // 테이블의 행과 열 순회
    Array.from(table.childNodes).forEach((node, rowIndex) => {
      Array.from(node.childNodes).forEach((tr) => {
        Array.from(tr.childNodes).forEach((cell, colIndex) => {
          const isRowSpanCell = rowSpanInfo.count > 1 && rowSpanInfo.col === colIndex;

          const bold = cell.style.fontWeight === 'bold';
          const color = isRowSpanCell ? '' : cell.style.color;
          const bg = isRowSpanCell ? '' : cell.style.backgroundColor;

          const key = `${this.convExcelFormation(colIndex + 1)}${rowIndex + 1}`;
          style[key] = createStyle(style[key], { bold, color, bg });

          // ColSpan에 따른 스타일 확장
          for (let i = 1; i < cell.colSpan; i++) {
            const colKey = `${this.convExcelFormation(colIndex + 1 + i)}${rowIndex + 1}`;
            style[colKey] = createStyle(style[colKey], { bold, color: '', bg: '' });
          }

          // RowSpan 처리
          if (!isRowSpanCell && cell.rowSpan > 1) {
            rowSpanInfo.count = cell.rowSpan;
            rowSpanInfo.col = colIndex;
          } else if (isRowSpanCell) {
            rowSpanInfo.count--;
          }
        });
      });
    });

    return style;
  },
};

export const Decode = {
  getToken() {
    const token = Utils.getSessionStorage('token');
    // const store = useStore();
    // const token = store.getters["authority/token"];
    return token;
  },
  getDecode() {
    const token = Utils.getSessionStorage('token');
    // const store = useStore();
    // const token = store.getters["authority/token"];
    const decode = VueJwtDecode.decode(token);
    return decode;
  },
};

export const Approval = {
  formatList(list) {
    const APPROVAL_TYPE = {
      admitRequest: {
        label: '인정휴가지급',
        unit: '일',
        route: 'MobileReceptionAdmit',
        icon: 'icon-beach-access',
        multiple: true,
        key: 'employeeId',
      },
      mealCost: {
        label: '식대비',
        unit: '원',
        route: 'MobileReceptionMealcost',
        icon: 'icon-fastfood',
        multiple: true,
        key: 'employeeId',
      },
      businessTrip: {
        label: '출장보고서',
        unit: '원',
        route: 'MobileReceptionBusinesstrip',
        icon: 'icon-luggage',
        multiple: false,
        key: 'businessTripId',
      },
      expenseReport: {
        label: '지출결의서',
        unit: '원',
        route: 'MobileReceptionExpense',
        icon: 'icon-credit-card',
        multiple: false,
        key: 'expenseReportId',
      },
      holidayWork: {
        label: '휴일근무신청',
        unit: '-',
        route: 'MobileReceptionHolidaywork',
        icon: 'icon-work',
        multiple: false,
        key: 'holidayWorkId',
      },
      submit: {
        label: '품의서',
        unit: '원',
        route: 'MobileReceptionSumit',
        icon: 'icon-credit-card',
        multiple: false,
        key: 'submitId',
      },
    };

    const items = {};
    const approvals = [];
    Object.keys(list).forEach((key) => {
      list[key].forEach((i) => {
        const data = (items[key + i.employeeId] = items[key + i.employeeId] || {
          ...APPROVAL_TYPE[key],
          id: i[APPROVAL_TYPE[key].key],
          name: i.nameKr,
          total: 0,
        });
        switch (key) {
          case 'admitRequest':
            data.total += i.totalAdmit;
            break;
          case 'mealCost':
            i.mealCostDtoListedList.forEach((e) => {
              data.total += e.cost || 0;
            });
            break;
          case 'submit':
          case 'businessTrip':
          case 'expenseReport':
            data.total += i.totalCost || 0;
            break;
          case 'holidayWork': {
            const start = moment(i.startDt).format('MM.DD');
            const end = moment(i.endDt).format('MM.DD');
            data.date =
              start === end ? Moment.dayFormat(i.startDt, 'MM.DD') : `${start} ~ ${end}`;
            break;
          }
        }
        if (!data.multiple) {
          approvals.push({ ...data });
          delete items[key + i.employeeId];
        }
      });
    });
    // return Object.values(items);
    return approvals.concat(Object.values(items).filter((i) => i.id));
  },
};

export const objectToFormData = (formData, data, parentKey = '', fileKey = '') => {
  if (Array.isArray(data)) {
    data.forEach((item, index) => {
      objectToFormData(formData, item, `${parentKey}[${index}]`, fileKey);
    });
  } else if (typeof data === 'object' && data) {
    if (data instanceof File) {
      formData.append(fileKey, data);
    } else {
      Object.entries(data).forEach(([key, value]) => {
        if (parentKey) {
          objectToFormData(formData, value, `${parentKey}.${key}`, fileKey);
        } else {
          objectToFormData(formData, value, key, fileKey);
        }
      });
    }
  } else {
    if (data !== null && typeof data !== 'undefined') {
      formData.append(parentKey, data);
    }
  }
};

export const downloadFile = async (fileUrl, fileName) => {
  if (!fileUrl) return;
  const response = await axios.get(fileUrl, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true,
    },
    responseType: 'blob',
  });
  const newUrl = window.URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = newUrl;
  a.download = fileName;
  a.click();
  a.remove();
  window.URL.revokeObjectURL(newUrl);
};

export const createImageFileView = () => {
  const base64String = '...'; // base64 인코딩된 문자열
  const mimeType = 'image/jpeg'; // 이미지 타입
  const blob = dataURItoBlob(`data:${mimeType};base64,${base64String}`);

  function dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }
};

export const encodeImageToBase64 = (file, callback) => {
  const reader = new FileReader();
  reader.onloadend = () => {
    const result = reader.result;
    callback({
      base64String: reader.result.split(',')[1],
      preview: result,
    });
  };
  reader.readAsDataURL(file);
};
